import React, { useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Spacing from "../Spacing";

export default function ContactForm() {
  const [formdata, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
    recaptchaToken: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const handleRecaptcha = (token) => {
    setFormData({ ...formdata, recaptchaToken: token });
    setErrors((prevErrors) => ({ ...prevErrors, recaptchaToken: "" }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: "",
    }));
  };

  const validateForm = () => {
    let newErrors = {};

    if (!formdata.name.trim()) newErrors.name = "Name is required";
    if (!formdata.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formdata.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formdata.subject.trim()) newErrors.subject = "Subject is required";
    if (!formdata.message.trim()) newErrors.message = "Message is required";
    if (!formdata.recaptchaToken)
      newErrors.recaptchaToken = "Please complete the reCAPTCHA";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    try {
      const response = await fetch("https://mercuryhc.com/contact.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formdata),
      });

      if (response.ok) {
        alert("Your message has been sent successfully!");
        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
          recaptchaToken: "",
        });
      } else {
        alert("Something went wrong. Please try again.");
      }
    } catch (error) {
      alert("Error submitting the form. Please try again later.");
    }
    setLoading(false);
  };

  return (
    <div className="cs_contact_form cs_style_1 cs_white_bg cs_radius_30">
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">Name</label>
            <input
              type="text"
              className="cs_form_field"
              placeholder="David John"
              name="name"
              value={formdata.name}
              onChange={handleChange}
            />
            {errors.name && <p className="error-text">{errors.name}</p>}
          </div>
          <div className="col-lg-6">
            <label className="cs_input_label cs_heading_color">Email</label>
            <input
              type="email"
              className="cs_form_field"
              placeholder="example@gmail.com"
              name="email"
              value={formdata.email}
              onChange={handleChange}
            />
            {errors.email && <p className="error-text">{errors.email}</p>}
          </div>
          <div className="col-lg-12">
            <label className="cs_input_label cs_heading_color">Subject</label>
            <input
              type="text"
              className="cs_form_field"
              placeholder="Your subject"
              name="subject"
              value={formdata.subject}
              onChange={handleChange}
            />
            {errors.subject && <p className="error-text">{errors.subject}</p>}
          </div>
          <div className="col-lg-12">
            <label className="cs_input_label cs_heading_color">Message</label>
            <textarea
              cols={30}
              rows={10}
              className="cs_form_field"
              placeholder="Write something..."
              name="message"
              value={formdata.message}
              onChange={handleChange}
            />
            {errors.message && <p className="error-text">{errors.message}</p>}
          </div>
          <Spacing md="35" />
          <div className="col-lg-12">
            <ReCAPTCHA
              sitekey="6LckUL8qAAAAAFVSLnb4EzLyqQqkwpe8XaQUh8fF"
              onChange={handleRecaptcha}
            />
            {errors.recaptchaToken && (
              <p className="error-text">{errors.recaptchaToken}</p>
            )}
          </div>
          <Spacing md="35" />
          <div className="col-lg-12">
            <button
              className="cs_btn cs_style_1"
              type="submit"
              disabled={loading}
            >
              <span>{loading ? "Submitting..." : "Submit"}</span>
              <i>
                <img src="/images/icons/arrow_white.svg" alt="Icon" />
                <img src="/images/icons/arrow_white.svg" alt="Icon" />
              </i>
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
